// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2364748b%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-page {
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: #f8fafc;
  padding: 4rem 1rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  overflow-y: auto;
}

.register-container {
  background: #ffffff;
  border-radius: 12px;
  padding: 48px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04), 0 2px 10px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.register-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.register-logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-bottom: 1.5rem;
}

.register-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
  letter-spacing: -0.02em;
}

.register-header p {
  color: #64748b;
  font-size: 0.95rem;
}

.returning-badge {
  display: inline-block;
  background: #dcfce7;
  color: #16a34a;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  margin-top: 0.5rem;
}

.error-banner {
  background-color: #fff1f2;
  border: 1px solid #ffe4e6;
  color: #e11d48;
  padding: 14px;
  border-radius: 8px;
  font-size: 0.875rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.register-form .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.register-form .form-group {
  margin-bottom: 1.5rem;
}

.register-form label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 0.5rem;
}

.register-form input[type="text"],
.register-form input[type="email"],
.register-form input[type="tel"],
.register-form select,
.register-form textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  color: #1e293b;
  background: #ffffff;
  transition: all 0.2s ease;
  font-family: inherit;
  appearance: none;
}

.register-form select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1em;
  padding-right: 2.5rem;
}

.register-form input:focus,
.register-form select:focus,
.register-form textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.field-error {
  display: block;
  color: #e11d48;
  font-size: 0.8rem;
  font-weight: 500;
  margin-top: 0.4rem;
}

.consent-group {
  background: #f8fafc;
  padding: 1.25rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  margin-top: 1rem;
}

.register-form .checkbox-label {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  font-size: 0.875rem;
  color: #475569;
  line-height: 1.5;
  font-weight: 400;
  margin-bottom: 0;
}

.register-form .checkbox-label span {
  flex: 1 1;
}

.register-form .checkbox-label input[type="checkbox"] {
  appearance: none;
  background-color: #ffffff;
  margin: 0;
  font: inherit;
  color: currentColor;
  width: 1.25rem;
  height: 1.25rem;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.register-form .checkbox-label input[type="checkbox"]::before {
  content: "";
  width: 0.65rem;
  height: 0.65rem;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: center;
  transition: 120ms transform ease-in-out;
  background-color: white;
}

.register-form .checkbox-label input[type="checkbox"]:checked {
  background-color: #2563eb;
  border-color: #2563eb;
}

.register-form .checkbox-label input[type="checkbox"]:checked::before {
  transform: scale(1);
}

.register-form .checkbox-label input[type="checkbox"]:focus {
  outline: max(2px, 0.15em) solid rgba(59, 130, 246, 0.2);
  outline-offset: max(2px, 0.15em);
}

.btn-submit {
  width: 100%;
  padding: 14px;
  background-color: #2563eb;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 2rem;
}

.btn-submit:hover:not(:disabled) {
  background-color: #1d4ed8;
  transform: translateY(-1px);
}

.btn-submit:active:not(:disabled) {
  transform: translateY(0);
}

.btn-submit:disabled {
  background-color: #94a3b8;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 640px) {
  .register-page {
    padding: 1rem;
  }

  .register-container {
    padding: 32px 24px;
    border-radius: 10px;
  }

  .register-form .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/RegisterForm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,uFAAuF;EACvF,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,2EAA2E;EAC3E,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EAEpB,gBAAgB;AAClB;;AAEA;EACE,yDAAiS;EACjS,4BAA4B;EAC5B,sCAAsC;EACtC,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,uEAAuE;EACvE,mBAAmB;EACnB,wBAAwB;EACxB,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;EACvD,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,MAAM;EACR;AACF","sourcesContent":[".register-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  background-color: #f8fafc;\n  padding: 4rem 1rem;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  overflow-y: auto;\n}\n\n.register-container {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 48px;\n  width: 100%;\n  max-width: 600px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04), 0 2px 10px rgba(0, 0, 0, 0.02);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.register-header {\n  text-align: center;\n  margin-bottom: 2.5rem;\n}\n\n.register-logo {\n  width: 80px;\n  height: 80px;\n  object-fit: contain;\n  margin-bottom: 1.5rem;\n}\n\n.register-header h1 {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.02em;\n}\n\n.register-header p {\n  color: #64748b;\n  font-size: 0.95rem;\n}\n\n.returning-badge {\n  display: inline-block;\n  background: #dcfce7;\n  color: #16a34a;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  margin-top: 0.5rem;\n}\n\n.error-banner {\n  background-color: #fff1f2;\n  border: 1px solid #ffe4e6;\n  color: #e11d48;\n  padding: 14px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.register-form .form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.register-form .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.register-form label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #64748b;\n  margin-bottom: 0.5rem;\n}\n\n.register-form input[type=\"text\"],\n.register-form input[type=\"email\"],\n.register-form input[type=\"tel\"],\n.register-form select,\n.register-form textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  color: #1e293b;\n  background: #ffffff;\n  transition: all 0.2s ease;\n  font-family: inherit;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.register-form select {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: 1em;\n  padding-right: 2.5rem;\n}\n\n.register-form input:focus,\n.register-form select:focus,\n.register-form textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n}\n\n.field-error {\n  display: block;\n  color: #e11d48;\n  font-size: 0.8rem;\n  font-weight: 500;\n  margin-top: 0.4rem;\n}\n\n.consent-group {\n  background: #f8fafc;\n  padding: 1.25rem;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  margin-top: 1rem;\n}\n\n.register-form .checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  cursor: pointer;\n  font-size: 0.875rem;\n  color: #475569;\n  line-height: 1.5;\n  font-weight: 400;\n  margin-bottom: 0;\n}\n\n.register-form .checkbox-label span {\n  flex: 1;\n}\n\n.register-form .checkbox-label input[type=\"checkbox\"] {\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #ffffff;\n  margin: 0;\n  font: inherit;\n  color: currentColor;\n  width: 1.25rem;\n  height: 1.25rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  margin-right: 0.75rem;\n  flex-shrink: 0;\n}\n\n.register-form .checkbox-label input[type=\"checkbox\"]::before {\n  content: \"\";\n  width: 0.65rem;\n  height: 0.65rem;\n  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);\n  transform: scale(0);\n  transform-origin: center;\n  transition: 120ms transform ease-in-out;\n  background-color: white;\n}\n\n.register-form .checkbox-label input[type=\"checkbox\"]:checked {\n  background-color: #2563eb;\n  border-color: #2563eb;\n}\n\n.register-form .checkbox-label input[type=\"checkbox\"]:checked::before {\n  transform: scale(1);\n}\n\n.register-form .checkbox-label input[type=\"checkbox\"]:focus {\n  outline: max(2px, 0.15em) solid rgba(59, 130, 246, 0.2);\n  outline-offset: max(2px, 0.15em);\n}\n\n.btn-submit {\n  width: 100%;\n  padding: 14px;\n  background-color: #2563eb;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 2rem;\n}\n\n.btn-submit:hover:not(:disabled) {\n  background-color: #1d4ed8;\n  transform: translateY(-1px);\n}\n\n.btn-submit:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-submit:disabled {\n  background-color: #94a3b8;\n  cursor: not-allowed;\n  transform: none;\n}\n\n@media (max-width: 640px) {\n  .register-page {\n    padding: 1rem;\n  }\n\n  .register-container {\n    padding: 32px 24px;\n    border-radius: 10px;\n  }\n\n  .register-form .form-row {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
